// Docs section — workpaper + complete + reopen endpoints. Slice 4.
import { api } from "@/core/api/client";
import type { CompleteReportResponse } from "@/core/api/types";

export async function downloadWorkpaper(reportId: string): Promise<Blob> {
  // #121: POST — generating files the workpaper (stamps workpaper_generated_at),
  // which gates "Mark report complete".
  return api.postBlob(`/reports/${reportId}/workpaper.docx`);
}

export async function completeReport(reportId: string): Promise<CompleteReportResponse> {
  return api.post<CompleteReportResponse>(`/reports/${reportId}/complete`);
}

export async function reopenReport(reportId: string): Promise<CompleteReportResponse> {
  return api.post<CompleteReportResponse>(`/reports/${reportId}/reopen`);
}

export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
